import { config } from '../config';

const getAuthToken = () => {
  return localStorage.getItem('idToken');
};

export const connectorTypesService = {
  list: async (filters = {}) => {
    const params = new URLSearchParams();
    if (filters.name) params.append('name', filters.name);
    if (filters.limit) params.append('limit', filters.limit);

    const queryString = params.toString();
    const url = `${config.apiBaseUrl}/admin/connector-types${queryString ? `?${queryString}` : ''}`;

    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': getAuthToken()
      }
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.error?.message || 'Failed to fetch connector types');
    }

    return response.json();
  },

  get: async (id) => {
    const response = await fetch(`${config.apiBaseUrl}/admin/connector-types/${id}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': getAuthToken()
      }
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.error?.message || 'Failed to fetch connector type');
    }

    return response.json();
  },

  create: async (data) => {
    const response = await fetch(`${config.apiBaseUrl}/admin/connector-types`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': getAuthToken()
      },
      body: JSON.stringify(data)
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.error?.message || 'Failed to create connector type');
    }

    return response.json();
  },

  update: async (id, data) => {
    const response = await fetch(`${config.apiBaseUrl}/admin/connector-types/${id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': getAuthToken()
      },
      body: JSON.stringify(data)
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.error?.message || 'Failed to update connector type');
    }

    return response.json();
  },

  delete: async (id) => {
    const response = await fetch(`${config.apiBaseUrl}/admin/connector-types/${id}`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': getAuthToken()
      }
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.error?.message || 'Failed to delete connector type');
    }

    return response.json();
  }
};
